import { render, staticRenderFns } from "./ForgotUsername.vue?vue&type=template&id=1731e56c&scoped=true&"
import script from "./ForgotUsername.vue?vue&type=script&lang=js&"
export * from "./ForgotUsername.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1731e56c",
  null
  
)

export default component.exports